import { storyGallery } from '@modules/gallery/story-gallery.js'

document.querySelectorAll(`.article .body-text img`).forEach((img) => {
    if (!img.closest('a,.image-gallery,.story-image-gallery')) {
        const fullImg = new Image()
        fullImg.addEventListener('load', function () {
            const a = document.createElement('a')
            a.classList.add('photoswipe')
            a.dataset.gallery = 'article-gallery'
            a.href = this.src
            a.title = this.alt
            a.dataset.size = `${this.width}x${this.height}`
            img.parentNode.insertBefore(a, img)
            a.appendChild(img)
        })
        fullImg.src = img.src
    }
})

const cardLayout = document.querySelector('.article-profile.card-layout')
const autoStartStories = cardLayout ? 'true' : 'false' || window.innerWidth < 721
document.querySelectorAll(`.article-profile .story-image-gallery`).forEach((gallery) => {
    const story = new storyGallery(gallery, {
        autoStart: autoStartStories,
    })

    if (!autoStartStories) {
        const card = gallery.closest('.sizable-card')
        card.addEventListener('mouseenter', () => {
            story.start()
        })
        card.addEventListener('mouseleave', () => story.stop())
    }
})
